import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";

const schema = z.object({
    Name: z.string().min(1, "Name is required"),
    Description: z.string().optional(),
    Permissions: z.array(z.any()).optional(),
});

const roleResolver = zodResolver(schema);

export default roleResolver;
